import { Swiper, SwiperSlide } from "swiper/react"; 
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, Shield, Locate, User } from "lucide-react";

export default function HeroSlider() {
  const slides = [
    {
      title: "Our Services",
      desc: "New Way Security delivers professional protection tailored to commercial, healthcare, residential, and high-profile clients. Our team ensures safety with integrity and reliability.",
      icon: <Shield className="w-10 h-10 text-white" />,
      bg: "https://images.pexels.com/photos/2348359/pexels-photo-2348359.jpeg",
      link: "/service",
    },
    {
      title: "Nationwide Coverage",
      desc: "Proudly serving communities across Ontario Canada, New Way Security is ready to protect what matters most — wherever you are.",
      icon: <Locate className="w-10 h-10 text-white" />,
      bg: "https://img.freepik.com/free-photo/vehicle-road_23-2151919260.jpg",
      link: "/locations",
    },
    {
      title: "Careers with Us",
      desc: "We are committed to employing skilled professionals, including veterans, who want to build rewarding careers in security. Join a team that values dedication and service.",
      icon: <User className="w-10 h-10 text-white" />,
      bg: "https://images.pexels.com/photos/26492746/pexels-photo-26492746/free-photo-of-loaded-truck-on-road.jpeg",
      link: "/career",
    },
    {
      title: "Emergency Response",
      desc: "With a 24/7 operations and dispatch center, New Way Security maintains constant communication with our on-duty guards to ensure rapid response in any situation.",
      icon: <ShieldCheck className="w-10 h-10 text-white" />,
      bg: "https://images.pexels.com/photos/11053640/pexels-photo-11053640.jpeg",
      link: "/emergencies",
    },
  ];

  return (
    <section className="w-full">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 4500 }}
        loop
        pagination={{ clickable: true }}
        className="w-full py-4"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative h-[60vh] md:h-[65vh] w-full flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70 z-0" />

              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="relative z-10 bg-white/10 backdrop-blur-lg p-8 md:p-12 rounded-2xl shadow-2xl text-center border border-[#c4122f]/50 max-w-3xl mx-4"
              >
                <div className="mb-6">
                  <div className="bg-gradient-to-br from-[#c4122f] to-red-900 p-4 rounded-full shadow-lg inline-flex items-center justify-center">
                    {slide.icon}
                  </div>
                </div>

                <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 drop-shadow">
                  {slide.title}
                </h2>
                <p className="text-gray-100 text-lg md:text-xl mb-6 drop-shadow">
                  {slide.desc}
                </p>

                <Link
                  to={slide.link}
                  className="inline-block bg-gradient-to-r from-[#c4122f] to-red-900 hover:from-[#c4122f] hover:to-red-900 text-white px-6 py-3 rounded-full font-medium text-md shadow-lg transition-all duration-300 hover:scale-105"
                >
                  Explore More
                </Link>
              </motion.div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
